import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BrandLogo } from "./BrandLogo";
import { useBranding } from "../hooks/useBranding";

const NAV_LINKS = [
  { label: "Inicio", to: "/", type: "route" },
  { label: "3 Razones", to: "/#por-que-nosotros", type: "hash" },
  { label: "Mejorar mi póliza", to: "/#solicitud-cotizacion", type: "hash" },
];

export default function Header() {
  const [open, setOpen] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);
  const loc = useLocation();
  const { brand } = useBranding();
  React.useEffect(() => setOpen(false), [loc.pathname]);
  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className="sticky top-0 z-50 transition-all duration-300"
      style={{
        background: scrolled ? "rgba(255,255,255,0.85)" : "rgba(255,255,255,0.55)",
        backdropFilter: "blur(18px) saturate(180%)",
        WebkitBackdropFilter: "blur(18px) saturate(180%)",
        borderBottom: scrolled ? "1px solid var(--border-subtle)" : "1px solid transparent",
      }}
      data-testid="main-header"
    >
      <div className="container-x flex items-center justify-between py-4">
        <div className="flex items-center gap-3 md:gap-5 min-w-0">
          <Link to="/" className="group flex-shrink-0" data-testid="brand-link">
            <BrandLogo imgClassName="h-11 md:h-16" subline="Corredora CMF · Chile" corfo iconBg="transparent" />
          </Link>

          {brand && brand.cobrandeado && brand.logoDark && (
            <div className="flex items-center gap-2.5 md:gap-3 pl-3 md:pl-5 border-l flex-shrink-0" style={{ borderColor: "var(--border-medium)" }} data-testid="header-alliance">
              <span className="hidden sm:inline-block text-[9.5px] md:text-[10px] uppercase font-bold tracking-[0.15em] leading-tight" style={{ color: "var(--text-muted)" }}>
                En alianza<br/>con
              </span>
              <img
                src={brand.logoDark}
                alt={brand.name}
                className="h-9 md:h-12 object-contain"
                style={brand.logoInvertHeader ? { filter: "brightness(0) saturate(100%)", opacity: 0.85 } : undefined}
                data-testid="header-alliance-logo"
              />
            </div>
          )}
        </div>

        <div className="hidden md:flex items-center gap-9">
          <nav className="flex items-center gap-9">
            {NAV_LINKS.map((l) =>
              l.type === "hash" ? (
                <a
                  key={l.to}
                  href={l.to}
                  className="nav-link"
                  style={{ color: "var(--text-secondary)" }}
                  data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  {l.label}
                </a>
              ) : (
                <Link
                  key={l.to}
                  to={l.to}
                  className="nav-link"
                  style={{ color: "var(--text-secondary)" }}
                  data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  {l.label}
                </Link>
              )
            )}
          </nav>
          <a href="/#solicitud-cotizacion" className="btn-primary" data-testid="header-cta-contacto" style={{ padding: "0.7rem 1.25rem", fontSize: 13.5 }}>
            Contáctanos
          </a>
        </div>

        <button
          className="md:hidden"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="menu"
          style={{ color: "var(--brand-navy)" }}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t" style={{ borderColor: "var(--border-subtle)", background: "white" }}>
          <div className="container-x py-4 flex flex-col gap-3">
            {NAV_LINKS.map((l) =>
              l.type === "hash" ? (
                <a key={l.to} href={l.to} className="py-2 text-sm font-medium" data-testid={`mobile-nav-${l.label}`}>
                  {l.label}
                </a>
              ) : (
                <Link key={l.to} to={l.to} className="py-2 text-sm font-medium" data-testid={`mobile-nav-${l.label}`}>
                  {l.label}
                </Link>
              )
            )}
            <a href="/#solicitud-cotizacion" className="btn-primary mt-2 justify-center">
              Contáctanos
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
